import { render } from "./AnimatedPath.vue?vue&type=template&id=e85a4290"
import script from "./AnimatedPath.vue?vue&type=script&lang=js"
export * from "./AnimatedPath.vue?vue&type=script&lang=js"

import "./AnimatedPath.vue?vue&type=style&index=0&id=e85a4290&lang=scss"
script.render = render

export default script